import { SVGProps } from 'react';
const SvgIconInstagramCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 41.2 41.2"
    {...props}
  >
    <g transform="translate(-167.2 -3587.2)">
      <g transform="translate(167.8 3587.8)">
        <g transform="translate(0 0)">
          <path
            d="M932.789,3620.04a19.978,19.978,0,1,1,5.358-.726"
            transform="translate(-912.789 -3580.04)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.2}
          />
          <rect
            width={21.527}
            height={20.754}
            rx={4}
            transform="translate(9.518 9.623)"
            strokeWidth={1.2}
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <circle
            cx={4.619}
            cy={4.619}
            r={4.619}
            transform="translate(15.663 16.047)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.2}
          />
          <circle
            cx={1.406}
            cy={1.406}
            r={1.406}
            transform="translate(25.02 13.416)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.2}
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgIconInstagramCircle;
